import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import DefaultLayout from '../layouts/DefaultLayout';
import Customer from '../interfaces/Customer';
import { fetchWithAuth } from '../services/Fetch';
import Project from '../interfaces/Project';

const CustomersDetail: React.FC = () => {

    const { id } = useParams<{ id: string }>();
    const [customer, setCustomer] = useState<Customer | null>(null);
    const [projects, setProjects] = useState<Project[]>([]);    

    const fetchCustomer = async () => {
        try {
            const response = await fetchWithAuth('/customers/' + id);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();

            setCustomer(data as Customer);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };

    const fetchProjects = async () => {
        try {
            const response = await fetchWithAuth('/projects?customer=/api/customers/' + id);
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setProjects(data.member as Project[]);
        } catch (error) {
            console.error('Error fetching projects:', error);
        }
    };

    const copyIdentifier = (identifier: string) => {
        navigator.clipboard.writeText(identifier)
            .catch(err => alert('Erreur lors de la copie de l\'identifiant: ' + err));
    };

    useEffect(() => {
        fetchCustomer();
        fetchProjects();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    if (!customer) {
        return <DefaultLayout><h1>Chargement...</h1></DefaultLayout>;
    }

    return (
        <DefaultLayout>
            <h1>{customer.title}</h1>
            <div style={{ whiteSpace: 'pre-line' }}>{customer.description}</div>
            <h3 className='mt-5'>Liste des projets</h3>
            <table className="table table-striped mt-3">
                <thead>
                    <tr>
                        <th scope="col">Client</th>
                        <th scope="col">Nom</th>
                        <th scope="col">Url</th>
                        <th scope="col">Identifiant</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {projects.map(project => <tr key={project.id}>
                        <td>{project.customer?.title}</td>
                        <td>{project.name}</td>
                        <td><a href={project.url} target="_blank" rel="noreferrer">{project.url}</a></td>
                        <td>{project.id}</td>
                        <td>
                            <Link to={`/projects/${project.id}`} className="btn btn-primary">
                                Voir les rapports
                            </Link>
                            <Link to={`/projects/${project.id}/edit`} className="btn btn-secondary ms-2">
                                Modifier
                            </Link>
                            <button className="btn btn-secondary ms-2" onClick={() => copyIdentifier(project.id.toString())}>
                                Copier l&apos;identifiant
                            </button>
                        </td>
                    </tr>)}
                </tbody>
            </table>
            <Link to={`/projects/new?customer=${customer.id}`} className="btn btn-success">Ajouter un projet</Link>
        </DefaultLayout>
    );
}

export default CustomersDetail;